import { render, staticRenderFns } from "./add-detail.vue?vue&type=template&id=3418b543&scoped=true&"
import script from "./add-detail.vue?vue&type=script&lang=js&"
export * from "./add-detail.vue?vue&type=script&lang=js&"
import style0 from "./add-detail.vue?vue&type=style&index=0&id=3418b543&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3418b543",
  null
  
)

export default component.exports